import * as React from 'react';
import { animated, useSpring } from 'react-spring';

import { ToolButtonContext } from './ToolButton';

interface Props extends React.SVGProps<SVGSVGElement> {
  size?: number;
}

const SPRING_CONFIG = {
  tension: 300,
  friction: 10,
};

function IconWand({ size = 24, ...props }: Props) {
  const isBooped = React.use(ToolButtonContext);

  const wandSpring = useSpring({
    transform: `rotate(${isBooped ? 5 : 0}deg)`,
    transformOrigin: '14% 86%',
    config: SPRING_CONFIG,
  });

  const asterisk1Spring = useSpring({
    transform: isBooped
      ? 'scale(1.2) rotate(20deg)'
      : 'scale(1) rotate(0deg)',
    transformOrigin: `20.8% 33.3%`,
    config: {
      tension: 300,
      friction: 8,
    },
    delay: 0,
  });

  const asterisk2Spring = useSpring({
    transform: isBooped
      ? 'scale(1.16) rotate(20deg)'
      : 'scale(1) rotate(0deg)',
    transformOrigin: `79.2% 66.7%`,
    config: {
      tension: 350,
      friction: 9,
    },
    delay: 75,
  });

  const asterisk3Spring = useSpring({
    transform: isBooped
      ? 'scale(1.24) rotate(20deg)'
      : 'scale(1) rotate(0deg)',
    transformOrigin: `41.7% 12.5%`,
    delay: 150,
    config: {
      tension: 300,
      friction: 5,
    },
  });

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <animated.g style={wandSpring}>
        <path d="M19.6398 5.64005L18.3598 4.36004C18.2473 4.24636 18.1133 4.15612 17.9657 4.09452C17.8181 4.03293 17.6598 4.00122 17.4998 4.00122C17.3399 4.00122 17.1815 4.03293 17.0339 4.09452C16.8863 4.15612 16.7523 4.24636 16.6398 4.36004L2.3598 18.64C2.24612 18.7526 2.15587 18.8865 2.09428 19.0341C2.03269 19.1817 2.00098 19.3401 2.00098 19.5C2.00098 19.66 2.03269 19.8184 2.09428 19.966C2.15587 20.1136 2.24612 20.2475 2.3598 20.36L3.6398 21.64C3.75162 21.755 3.88534 21.8463 4.03305 21.9087C4.18076 21.971 4.33947 22.0031 4.4998 22.0031C4.66014 22.0031 4.81885 21.971 4.96656 21.9087C5.11427 21.8463 5.24798 21.755 5.3598 21.64L19.6398 7.36005C19.7547 7.24822 19.846 7.11451 19.9084 6.9668C19.9708 6.81909 20.0029 6.66038 20.0029 6.50005C20.0029 6.33971 19.9708 6.181 19.9084 6.03329C19.846 5.88558 19.7547 5.75187 19.6398 5.64005Z" />
        <path d="m14 7 3 3" />
      </animated.g>
      <animated.g style={asterisk1Spring}>
        <path d="M5 6v4" />
        <path d="M7 8H3" />
      </animated.g>
      <animated.g style={asterisk2Spring}>
        <path d="M19 14v4" />
        <path d="M21 16h-4" />
      </animated.g>
      <animated.g style={asterisk3Spring}>
        <path d="M10 2v2" />
        <path d="M11 3H9" />
      </animated.g>
    </svg>
  );
}

export default IconWand;
